import React from "react";

// Flickering brass Diya loader
export function DiyaLoader({ label = "లోడ్ అవుతోంది..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20" data-testid="diya-loader">
      <div className="relative">
        <div className="w-4 h-8 mx-auto animate-flicker diya-flame animate-glow" />
        <svg width="90" height="46" viewBox="0 0 90 46" className="-mt-1">
          <defs>
            <linearGradient id="brass" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#F59E0B" /><stop offset="60%" stopColor="#D97706" /><stop offset="100%" stopColor="#7F1D1D" />
            </linearGradient>
          </defs>
          <path d="M5 12 Q45 2 85 12 Q78 34 45 40 Q12 34 5 12 Z" fill="url(#brass)" stroke="#7F1D1D" strokeWidth="1.5" />
          <ellipse cx="45" cy="42" rx="20" ry="4" fill="#7F1D1D" opacity="0.3" />
        </svg>
      </div>
      <p className="mt-4 font-telugu text-maroon/80 text-sm tracking-wide">{label}</p>
    </div>
  );
}

// Mango-leaf Toranam divider
export function Toranam({ className = "" }) {
  const leaves = Array.from({ length: 18 });
  return (
    <div className={`w-full overflow-hidden select-none ${className}`} aria-hidden data-testid="toranam-divider">
      <svg viewBox="0 0 720 44" className="toranam-svg" preserveAspectRatio="none">
        <path d="M0 6 Q360 26 720 6" fill="none" stroke="#7F1D1D" strokeWidth="2" />
        {leaves.map((_, i) => {
          const x = 20 + i * 40;
          return (
            <g key={i} transform={`translate(${x}, 8)`}>
              <path d="M0 0 Q9 20 0 34 Q-9 20 0 0 Z" fill={i % 2 ? "#C2410C" : "#D97706"} stroke="#7F1D1D" strokeWidth="0.6" />
              <line x1="0" y1="2" x2="0" y2="30" stroke="#7F1D1D" strokeWidth="0.5" opacity="0.5" />
            </g>
          );
        })}
      </svg>
    </div>
  );
}
